import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { Navigate, useParams, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/core/hooks/useAuth';
import { LoginButtons } from '@/features/auth/LoginButtons';

export function AdminLoginPage() {
  const { raceAlias } = useParams<{ raceAlias: string }>();
  const { user, loading: authLoading } = useAuth();
  const [searchParams] = useSearchParams();
  const error = searchParams.get('error');

  // ログイン後のリダイレクト先
  const returnUrl = raceAlias ? `/${raceAlias}/admin/minting` : '/admin/clients';

  // ログイン済みならリダイレクト
  if (!authLoading && user) {
    return <Navigate to={returnUrl} replace />;
  }

  const title = raceAlias ? '大会管理画面' : '運営管理画面';

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Box sx={{ textAlign: 'center', mb: 4 }}>
        <Typography variant="h5" component="h1" gutterBottom>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          管理画面にアクセスするにはログインが必要です
        </Typography>
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}

      <LoginButtons returnUrl={returnUrl} />

      <Divider sx={{ my: 4 }} />

      <Typography variant="body2" color="text.secondary" align="center">
        ログインすることで、利用規約とプライバシーポリシーに同意したものとみなされます。
      </Typography>
    </Container>
  );
}
